<template>
  <v-row>
    <span
      class="reference-title"
      @click="open"
    >
      {{ title }}
    </span>
    <slot
      v-if="$slots.quantity"
      name="quantity" 
    />
    <ModalWindow
      v-model="showModal"
      :id="referenceId"
      :component-name="componentName"
      @close="showModal = false"
    />
  </v-row>
</template>

<script>
import ModalWindow from "./ModalWindow";

export default {
  components: {
    ModalWindow,
  },
  props: ["componentName", "title", "id"],
  data: () => ({
    referenceId: null,
    showModal: false,
  }),
  methods: {
    open() {
      if (this.id) {
        this.referenceId = this.id;
        this.showModal = true;
      }
    },
    close() {
      this.referenceId = null;
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
.reference-title:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
